import { render, staticRenderFns } from "./typeOthers.vue?vue&type=template&id=563479ed&scoped=true&"
import script from "./typeOthers.vue?vue&type=script&lang=js&"
export * from "./typeOthers.vue?vue&type=script&lang=js&"
import style0 from "./typeOthers.vue?vue&type=style&index=0&id=563479ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563479ed",
  null
  
)

export default component.exports